export default {
  tableTabs: [
    {
      title: "جميع العملات المشفرة",
      id: 1
    },
    {
      title: "المفضلة",
      id: 2
    }
  ],
  searchInputPlaceholder: "ابحث عن اسم العملة أو الرمز...",
  categoriesMenu: ["الأكثر شهرة", "الأرخص", "الأغلى"],
  headers: [
    {
      text: "",
      align: "center",
      sortable: false,
      value: "fave",
      width: 70
    },
    {
      text: "#",
      align: "center",
      sortable: true,
      value: "rank",
      width: 70
    },
    {
      text: "اسم العملة",
      align: "start",
      sortable: true,
      value: "name_locale"
    },
    {
      text: "السعر (USD)",
      value: "price",
      align: "right",
      sortable: true
    },
    {
      text: "تغييرات 24 ساعة",
      value: "daily_change_percent",
      align: "right",
      sortable: true
    },
    {
      text: "سعر البيع (IRR)",
      value: "price_buy",
      align: "right",
      sortable: true
    },
    {
      text: "سعر الشراء (IRR)",
      value: "price_sell",
      align: "right",
      sortable: true
    },
    {
      text: "القيمة السوقية (USD)",
      value: "market_cap",
      align: "right",
      sortable: true
    }
  ],
  noResults: "لم يتم العثور على نتائج.",
  noResultsForFave: "قائمة المفضلة الخاصة بك فارغة."
};
